/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Minus Icon
 *
 * @file MinusIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropType from 'prop-types';

const MinusIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M27.9 9.42399C25.576 7.41199 22.552 6.18799 19.24 6.18799C11.94 6.18799 6 12.128 6 19.428C6 24.092 8.428 28.196 12.08 30.556C14.404 32.58 17.44 33.808 20.76 33.808C28.06 33.808 34 27.868 34 20.568C34 15.896 31.564 11.78 27.9 9.42399ZM19.24 7.39199C25.876 7.39199 31.28 12.792 31.28 19.432C31.28 26.072 25.88 31.472 19.24 31.472C12.6 31.472 7.2 26.072 7.2 19.432C7.2 12.792 12.6 7.39199 19.24 7.39199Z" fill="currentColor" />
    <path d="M11.476 20.032H27.004C27.336 20.032 27.604 19.764 27.604 19.432C27.604 19.1 27.336 18.832 27.004 18.832H11.476C11.144 18.832 10.876 19.1 10.876 19.432C10.876 19.764 11.144 20.032 11.476 20.032Z" fill="currentColor" />
  </SvgIcon>
);

MinusIcon.propTypes = {
  className: PropType.string.isRequired
};

export default MinusIcon;

